import Card from 'react-bootstrap/Card';
import Form from 'react-bootstrap/Form';
import Dropdown from 'react-bootstrap/Dropdown';
import { IconGrip, IconPencil, IconTrash, IconMoreVertical, IconChevronDown, IconImage } from '../atoms/Icon';

function formatPrice(price) {
  return Number(price).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

function MenuItem({ product, categoryIcon, onEdit, onDelete, onToggleAvailability, onMoveUp, onMoveDown, innerRef, draggableProps, dragHandleProps, isDragging }) {
  const { name, description, price, isAvailable, variants, addons, imageUrl } = product;
  const hints = [];
  if (variants?.length) hints.push(`${variants.length} ${variants.length > 1 ? 'variações' : 'variação'}`);
  if (addons?.length) hints.push(`${addons.length} ${addons.length > 1 ? 'adicionais' : 'adicional'}`);
  // Uma única linha secundária: descrição tem prioridade, e as contagens de
  // variações/adicionais só aparecem quando não há descrição — duas linhas
  // extras deixariam de caber na faixa única de ~68px.
  const secondaryLine = description || (hints.length > 0 ? hints.join(' · ') : '');

  const variantPrices = variants?.map((v) => Number(v.price)) || [];
  const hasVariants = variantPrices.length > 0;
  const minPrice = hasVariants ? Math.min(...variantPrices) : Number(price);
  const maxPrice = hasVariants ? Math.max(...variantPrices) : Number(price);
  const priceLabel = !hasVariants
    ? `R$ ${formatPrice(price)}`
    : minPrice === maxPrice
      ? `R$ ${formatPrice(minPrice)}`
      : `A partir de R$ ${formatPrice(minPrice)}`;

  return (
    <Card
      ref={innerRef}
      {...draggableProps}
      className={`border-0 mb-2 menu-item-row${isDragging ? ' menu-item-dragging' : ' card-elevated'}`}
      style={{
        borderRadius: 'var(--radius-md)',
        opacity: isAvailable ? 1 : 0.6,
        ...(draggableProps?.style || {}),
      }}
    >
      <Card.Body className="menu-item-body d-flex align-items-center gap-3">
        {dragHandleProps && (
          <span
            {...dragHandleProps}
            className="drag-handle menu-item-drag-handle"
            title="Arraste para reordenar"
            aria-label="Arraste para reordenar"
          >
            <IconGrip size={16} />
          </span>
        )}
        <div className="menu-item-thumb">
          {imageUrl ? (
            <img src={imageUrl} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
          ) : categoryIcon ? (
            <span className="thumb-emoji" aria-hidden="true">{categoryIcon}</span>
          ) : (
            <IconImage size={18} style={{ color: '#bbb' }} />
          )}
        </div>

        <div className="flex-grow-1" style={{ minWidth: 0 }}>
          <div className="menu-item-name">{name}</div>
          <div className="menu-item-secondary">{secondaryLine}</div>
        </div>

        <div className="menu-item-switch-col">
          <Form.Check
            type="switch"
            checked={isAvailable}
            onChange={onToggleAvailability}
            title={isAvailable ? 'Disponível — clique para tirar de venda' : 'Indisponível — clique para voltar à venda'}
            aria-label={`${name}: ${isAvailable ? 'disponível' : 'indisponível'}`}
            className="mb-0"
          />
        </div>

        <span className="menu-item-price">{priceLabel}</span>

        <div className="d-flex gap-1 flex-shrink-0">
          {/* Num celular o nome do produto já disputa espaço com miniatura,
              switch e preço — juntar editar ao mesmo menu de "mais ações"
              libera uma coluna inteira de botão sem tirar a ação de lugar
              nenhum, só de um clique a mais nessa largura de tela. */}
          <button
            type="button"
            className="action-btn icon-btn action-btn-muted d-none d-sm-inline-flex"
            onClick={onEdit}
            title="Editar produto"
            aria-label="Editar produto"
          >
            <IconPencil size={15} />
          </button>
          <Dropdown align="end">
            <Dropdown.Toggle
              as="button"
              type="button"
              bsPrefix="action-btn icon-btn action-btn-muted"
              title="Mais ações"
              aria-label="Mais ações"
            >
              <IconMoreVertical size={15} />
            </Dropdown.Toggle>
            <Dropdown.Menu style={{ minWidth: 160, borderRadius: 10, fontSize: 13 }}>
              <Dropdown.Item
                onClick={onEdit}
                className="d-sm-none d-flex align-items-center gap-2"
                style={{ borderRadius: 6, padding: '8px 10px' }}
              >
                <IconPencil size={14} /> Editar produto
              </Dropdown.Item>
              {/* Alternativa ao arrastar — que some no celular e nem todo
                  mundo confia no toque pra reordenar mesmo no desktop. */}
              {onMoveUp && (
                <Dropdown.Item
                  onClick={onMoveUp}
                  className="d-flex align-items-center gap-2"
                  style={{ borderRadius: 6, padding: '8px 10px' }}
                >
                  <IconChevronDown size={14} style={{ transform: 'rotate(180deg)' }} /> Mover para cima
                </Dropdown.Item>
              )}
              {onMoveDown && (
                <Dropdown.Item
                  onClick={onMoveDown}
                  className="d-flex align-items-center gap-2"
                  style={{ borderRadius: 6, padding: '8px 10px' }}
                >
                  <IconChevronDown size={14} /> Mover para baixo
                </Dropdown.Item>
              )}
              <Dropdown.Item
                onClick={onDelete}
                className="d-flex align-items-center gap-2"
                style={{ color: '#e74c3c', borderRadius: 6, padding: '8px 10px' }}
              >
                <IconTrash size={14} /> Excluir produto
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </Card.Body>
    </Card>
  );
}

export default MenuItem;
